import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PLAYLIST_ENDPOINT_URL } from '../../../common/constants/request';

import logger from '../../../common/helpers/logger';
import { includeFeatures, tmPostRequest } from '../../../common/helpers/request';
import { getFormattedVideo } from '../../../common/helpers/video';
import * as commonSelectors from '../../../common/redux/selectors/common';
import {
  shareVideoFetchErrorAction,
  shareVideoFetchStartedAction,
  shareVideoFetchSuccessAction,
} from '../slices/share';

export default (action$, state$) =>
  action$.pipe(
    ofType(shareVideoFetchStartedAction.type),
    switchMap(({ payload: { matchingId } }) => {
      const publisher = commonSelectors.publisherSelector(state$.value);
      const player = commonSelectors.playerSelector(state$.value);

      const stream$ = tmPostRequest({
        url: PLAYLIST_ENDPOINT_URL,
        body: {
          videoHub: true,
          publisherId: publisher.slug,
          widgetId: player.name,
          url: window.location.href,
          matchingId,
          includeSource: true,
          ...includeFeatures(state$.value),
        },
      }).pipe(
        map(({ response }) => {
          const { playlist, errors, ...playerPropsPassThrow } = response ?? {};

          const payload = {
            playerPropsPassThrow,
            playlist: (playlist || []).map((videoS) =>
              getFormattedVideo(videoS, {
                signedUrlExp: playerPropsPassThrow.signedUrlExp,
              }),
            ),
          };

          return shareVideoFetchSuccessAction(payload);
        }),
        catchError((error) => {
          logger.error(
            'Error of the share video request',
            'src/modules/PlayerOverview/redux/epics/getSingleOverview.js',
            error,
          );

          return of(shareVideoFetchErrorAction());
        }),
      );

      return concat(stream$);
    }),
  );
